import styled, { css } from 'styled-components';

export const TitleStyle = styled.div`
  ${({ theme: { spacing } }) => css`
    margin-top: ${spacing.px10};
    > div {
      margin-bottom: 20px !important;
    }
  `}
`;

export const ButtonApply = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const IconStyled = styled.div`
  ${({ theme: { fontSize, colors } }) => css`
    font-size: ${fontSize.px18};
    color: ${colors.blueGrey3};
  `}
`;

export const ButtonStyled = styled.button`
  ${({ theme: { colors, spacing, fontSize, fontWeight } }) => css`
    display: flex;
    align-items: center;
    color: ${colors.blueGrey3};
    background-color: ${colors.white};
    text-align: center;
    outline: none;
    border: none;
    line-height: 1;
    transition: all 0.3s;
    margin-left: ${spacing.px24};
    font-size: ${fontSize.px14};

    font-weight: ${fontWeight.light};
    position: relative;
    top: 0;
    transition: all 0.2s;
    cursor: pointer;
    white-space: nowrap;
    padding: ${spacing.px15} ${spacing.none};
    border-bottom: 2px solid ${colors.blue2};
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &:active {
      box-shadow: 0 0 0 ${colors.active.blue2};
    }
    & > span {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  `}
`;

export const DateTextStyled = styled.div`
  ${({ theme: { spacing } }) => css`
    margin-left: ${spacing.px8};
  `}
`;
